// Philippines Insurance Policy Receipts Mock Data

export const data = [
  {
    id: 1,
    receiptNumber: "OR-2025-03-0001",
    transactionCode: "PREM-COL",
    transactionNumber: "TRN-2025030001",
    name: "Juan Dela Cruz",
    customerCode: "CL-2025-001",
    policyNumber: "MIC-2025-MOT-00123",
    insurer: "Malayan Insurance",
    date: "03/28/2025",
    amount: "₱22,500.00",
    paymentMethod: "GCash",
    status: "Validated",
    referenceNumber: "GC-2025032801234"
  },
  {
    id: 2,
    receiptNumber: "OR-2025-03-0002",
    transactionCode: "PREM-COL",
    transactionNumber: "TRN-2025030002",
    name: "Maria Santos",
    customerCode: "CL-2025-002",
    policyNumber: "PGA-2025-MOT-00456",
    insurer: "PGA Sompo",
    date: "03/27/2025",
    amount: "₱18,500.00",
    paymentMethod: "Bank Transfer",
    status: "Validated",
    bankName: "BDO",
    referenceNumber: "BDO-2025032712345"
  },
  {
    id: 3,
    receiptNumber: "OR-2025-03-0003",
    transactionCode: "PREM-COL",
    transactionNumber: "TRN-2025030003",
    name: "Ayala Corporation",
    customerCode: "CL-2025-003",
    policyNumber: "AXA-2025-HLT-00567",
    insurer: "AXA Philippines",
    date: "03/26/2025",
    amount: "₱625,000.00",
    paymentMethod: "Check",
    status: "For Deposit",
    checkNumber: "MBTC-123456",
    checkDate: "03/26/2025"
  },
  {
    id: 4,
    receiptNumber: "OR-2025-03-0004",
    transactionCode: "PREM-COL",
    transactionNumber: "TRN-2025030004",
    name: "Ana Garcia",
    customerCode: "CL-2025-004",
    policyNumber: "CHA-2025-FIRE-01012",
    insurer: "Charter Ping An",
    date: "03/25/2025",
    amount: "₱45,000.00",
    paymentMethod: "Check",
    status: "Cleared",
    checkNumber: "BPI-987654",
    depositDate: "03/26/2025"
  },
  {
    id: 5,
    receiptNumber: "OR-2025-03-0005",
    transactionCode: "ENDORSEMENT",
    transactionNumber: "TRN-2025030005",
    name: "Pedro Gonzales",
    customerCode: "CL-2025-005",
    policyNumber: "FPG-2025-MOT-01315",
    insurer: "FPG Insurance",
    date: "03/24/2025",
    amount: "₱3,500.00",
    paymentMethod: "PayMaya",
    status: "Validated",
    description: "Additional coverage - Acts of God",
    referenceNumber: "PM-2025032423456"
  },
  {
    id: 6,
    receiptNumber: "OR-2025-03-0006",
    transactionCode: "RENEWAL",
    transactionNumber: "TRN-2025030006",
    name: "Rosa Fernandez",
    customerCode: "CL-2025-006",
    policyNumber: "PIO-2025-TRV-01618",
    insurer: "Pioneer Insurance",
    date: "03/23/2025",
    amount: "₱3,500.00",
    paymentMethod: "Cash",
    status: "Validated",
    orCopyIssued: true
  },
  {
    id: 7,
    receiptNumber: "OR-2025-03-0007",
    transactionCode: "PREM-COL",
    transactionNumber: "TRN-2025030007",
    name: "SM Prime Holdings",
    customerCode: "CL-2025-007",
    policyNumber: "CHA-2025-FIRE-00189",
    insurer: "Charter Ping An",
    date: "03/22/2025",
    amount: "₱625,000.00",
    paymentMethod: "Bank Transfer",
    status: "Validated",
    bankName: "MBTC",
    description: "Q1 2025 Premium Payment",
    referenceNumber: "MBTC-2025032234567"
  },
  {
    id: 8,
    receiptNumber: "OR-2025-03-0008",
    transactionCode: "CTPL",
    transactionNumber: "TRN-2025030008",
    name: "Elena Martinez",
    customerCode: "CL-2025-008",
    policyNumber: "MIC-2025-CTPL-02224",
    insurer: "Malayan Insurance",
    date: "03/21/2025",
    amount: "₱1,800.00",
    paymentMethod: "Cash",
    status: "Validated",
    ctplSticker: "Issued"
  },
  {
    id: 9,
    receiptNumber: "OR-2025-03-0009",
    transactionCode: "PREM-COL",
    transactionNumber: "TRN-2025030009",
    name: "2GO Group Inc.",
    customerCode: "CL-2025-009",
    policyNumber: "STD-2025-MAR-01921",
    insurer: "Standard Insurance",
    date: "03/20/2025",
    amount: "₱125,000.00",
    paymentMethod: "Bank Transfer",
    status: "Pending Verification",
    bankName: "BPI",
    referenceNumber: "BPI-2025032089012"
  },
  {
    id: 10,
    receiptNumber: "OR-2025-03-0010",
    transactionCode: "PREM-COL",
    transactionNumber: "TRN-2025030010",
    name: "Carmen Bautista",
    customerCode: "CL-2025-010",
    policyNumber: "PGA-2025-PROP-02830",
    insurer: "PGA Sompo",
    date: "03/19/2025",
    amount: "₱28,000.00",
    paymentMethod: "Credit Card",
    status: "Validated",
    cardType: "Visa",
    lastFourDigits: "4567"
  },
  {
    id: 11,
    receiptNumber: "OR-2025-03-0011",
    transactionCode: "REFUND",
    transactionNumber: "TRN-2025030011",
    name: "Miguel Torres",
    customerCode: "CL-2025-011",
    policyNumber: "AXA-2025-PA-03456",
    insurer: "AXA Philippines",
    date: "03/18/2025",
    amount: "(₱2,500.00)",
    paymentMethod: "Bank Transfer",
    status: "Processed",
    description: "Policy cancellation refund",
    refundReference: "REF-2025031812345"
  },
  {
    id: 12,
    receiptNumber: "OR-2025-03-0012",
    transactionCode: "INSTALLMENT",
    transactionNumber: "TRN-2025030012",
    name: "Jollibee Foods Corporation",
    customerCode: "CL-2025-012",
    policyNumber: "MAX-2025-HMO-08901",
    insurer: "Maxicare",
    date: "03/17/2025",
    amount: "₱208,333.33",
    paymentMethod: "Auto-Debit",
    status: "Validated",
    description: "Monthly installment 3 of 12",
    bankName: "Security Bank"
  }
];

// Receipt Summary Statistics
export const receiptSummary = {
  totalReceipts: 12,
  totalAmount: "₱1,832,133.33",
  pendingVerification: 1,
  validated: 10,
  forDeposit: 1,
  averageReceiptAmount: "₱152,677.78"
};

// Transaction Types Distribution
export const transactionTypes = [
  { type: "Premium Collection", code: "PREM-COL", count: 7, amount: "₱1,661,333.33" },
  { type: "CTPL", code: "CTPL", count: 1, amount: "₱1,800.00" },
  { type: "Endorsement", code: "ENDORSEMENT", count: 1, amount: "₱3,500.00" },
  { type: "Renewal", code: "RENEWAL", count: 1, amount: "₱3,500.00" },
  { type: "Installment", code: "INSTALLMENT", count: 1, amount: "₱208,333.33" },
  { type: "Refund", code: "REFUND", count: 1, amount: "(₱2,500.00)" }
];

export default data;